<template>
  <aside v-if="ad" class="house-ad" aria-label="Explore the Keelara app family">
    <span class="house-ad__label">Explore the Keelara family</span>
    <div class="house-ad__frame-wrap">
      <iframe
        :src="src"
        :title="ad.title"
        loading="lazy"
        scrolling="no"
        frameborder="0"
        class="house-ad__frame"
      ></iframe>
    </div>
  </aside>
</template>

<script setup>
import { ref, computed } from 'vue'

// House-ad rotator for Papersnap (a suite of one). Pool = EVERY other Keelara
// app with a leaderboard creative (papersnap itself excluded). Round-robin per
// page load via a shared localStorage counter (random fallback), so each refresh
// advances to the next app. Add an app here + drop its creative into public/ads/.
const ADS = [
  { app: 'trackcv', file: 'trackcv-leaderboard-970x250.html', title: 'TrackCV — see which resume version actually gets replies' },
  { app: 'crushmyinterview', file: 'crushmyinterview-leaderboard-970x250.html', title: 'CrushMyInterview — get AI feedback on your interview answers' },
  { app: 'mypassionjob', file: 'mypassionjob-leaderboard-970x250.html', title: 'MyPassionJob — score how well your work fits what you love' },
  { app: 'enoughmoneyplan', file: 'enoughmoneyplan-leaderboard-970x250.html', title: 'EnoughMoneyPlan — find your enough number and the plan to reach it' },
  { app: 'promptcuelab', file: 'promptcuelab-leaderboard-970x250.html', title: 'PromptCueLab — a curated AI prompt library + refiner' },
  { app: 'craftmyflow', file: 'craftmyflow-leaderboard-970x250.html', title: 'CraftMyFlow — score any workflow and find what to automate' },
  { app: 'craftmystack', file: 'craftmystack-leaderboard-970x250.html', title: 'CraftMyStack — get an AI-matched tech stack for your project' },
  { app: 'matchmytool', file: 'matchmytool-leaderboard-970x250.html', title: 'MatchMyTool — find the right tools, matched to your needs' },
  { app: 'cooksurprise', file: 'cooksurprise-leaderboard-970x250.html', title: 'CookSurprise — a surprise recipe in one tap, matched to what you have' },
  { app: 'mixsurprise', file: 'mixsurprise-leaderboard-970x250.html', title: 'MixSurprise — find a cocktail you can actually make tonight' },
  { app: 'paidharbor', file: 'paidharbor-leaderboard-970x250.html', title: 'PaidHarbor — free invoice generator & get-paid tools' },
]

const SOURCE = 'papersnap'
const POOL = ADS.filter((a) => a.app !== SOURCE)

function pick() {
  if (!POOL.length) return null
  try {
    const key = 'keelara:housead:idx'
    const prev = parseInt(window.localStorage.getItem(key) || '-1', 10)
    const idx = ((Number.isInteger(prev) ? prev + 1 : 0) % POOL.length + POOL.length) % POOL.length
    window.localStorage.setItem(key, String(idx))
    return POOL[idx]
  } catch {
    return POOL[Math.floor(Math.random() * POOL.length)]
  }
}

const ad = ref(pick())

const src = computed(() =>
  ad.value ? `/ads/${ad.value.file}?utm_source=${SOURCE}` : '',
)
</script>

<style scoped>
.house-ad { display: flex; flex-direction: column; align-items: center; gap: 0.5rem; width: 100%; max-width: 970px; margin: 0 auto; padding: 0 1rem; }
.house-ad__label { font-size: 11px; letter-spacing: 0.1em; text-transform: uppercase; color: #94a3b8; }
.house-ad__frame-wrap { width: 100%; max-width: 970px; aspect-ratio: 970 / 250; border-radius: 16px; overflow: hidden; box-shadow: 0 10px 34px rgba(0, 0, 0, 0.22); }
.house-ad__frame { display: block; width: 100%; height: 100%; border: 0; }
</style>
